export const colors = {
  black: "#000000",
  biscay: "#1c466c",
  darkGrey: "#3A3A3B",
  darkGrey100: "#8c8c8c",
  grey700: "#707070",
  grey600: "#C3C3C3",
  grey500: "#333333",
  grey400: "#00000080",
  grey300: "#00000038",
  grey200: "#d8d5d1",
  grey100: "#e5e6e6",
  grey150: "#7d7a7a",
  skyBlue: "#436BEC",
  lightGrey: "#CFD4DA",
  lightGrey100: "#50515B",
  lightLavender: "#F9FAFF",
  grey50: "#e5e5e5",
  grey: "#f6f6f6",
  grey800: "#5B5B5C",
  blueGrey: "#F1F4F6",
  lightBlue: "#ddf3f6",
  linkBlue: "#4285F4",
  primaryPurple: "#454CA0",
  lightPurple: "#5359AA",
  cornflowerBlue: "#4285F4",
  disabledBlue: "#4285F499",
  blue100: "#F9FAFB",
  red: "#ff0000",
  lightRed: "#fae1e0",
  white: "#ffffff",
  primaryBlueGrey: "#3A627E",
  lightBlueGrey: "#C1CDD6",
  darkBlueGrey: "#2a465a",
  disabledBlueGrey: "#81aac8",
  cream: "#EDEAE6",
  darkCream: "#DDD8CF",
}
